export const AuthMetricEvents = {
  BuildVersionUsed: 'Build Version Used',
}